export default "__VITE_ASSET__DFVtXDsm__"